// extracted by mini-css-extract-plugin
module.exports = {"root":"F0LU6rRlCMD0rs4TeMog","image":"T8ojgBt0jLZhQBc7mSKE"};